import moment from 'moment'

export default () => ({
  agendaCovenant: [],
  covenantResource: [],
  booking: false,
  alertCovenantNotExist: false,
  countdown: moment().add(300, 'seconds'),
  reserving: true,
  covenant: {
    id: null,
    label: null
  },
  patient: {
    id: null,
    label: null,
    type: null
  },
  covenants: [],
  started: false,
  optionPrivate: [
    {id: null, name: 'Particular'}
  ],
  activeSchedules: true,
  activeMsgSelectCovenant: false,
  doesNotAttend: false,
  schedulingProcessing: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/data.js